import { z } from 'zod';

/**
 * Legacy stores `0` as the "no value" sentinel for nullable FK columns
 * (`patientID`, `patientPlanID`, `appointmentTypeGroupID`). The DB columns
 * are `int NOT NULL DEFAULT 0`, so the API can — and does — emit `0`
 * rather than `null`. A blanket `.positive()` rule therefore makes legacy
 * rows un-loadable in the modal ("Patient plan: Number must be greater
 * than 0"). This helper accepts `0`, `'0'`, `''`, `null`, or `undefined`
 * as "no value" and normalizes to `undefined`, so downstream form code
 * treats absence consistently.
 *
 * Reference: `docs/audit/appt-details-parity.md` §5.A and §6 P1.
 */
export const optionalLegacyForeignKey = z.preprocess(
  (v) => (v === 0 || v === '0' || v === '' || v === null ? undefined : v),
  z.number().int().positive().optional(),
);
